import { SessionStorage } from '@convincely/utils/lib/services/storage.js';
export const asyncStorage = new SessionStorage('async_');
//# sourceMappingURL=storage.js.map